import React, { useState } from 'react'
import ProjectRoute from './Routes/ProjectRoute'
import { PersistGate } from 'redux-persist/integration/react';
import persistStore from 'redux-persist/es/persistStore';
import { Provider } from 'react-redux';
import { store } from './Redux/store';
import { PrimeReactProvider } from 'primereact/api';
import ThemeProvider from './Components/Utils/ThemeProvider';
let persistor = persistStore(store)


export default function App() {
  const [lodingSpinner, setLodingSpinner] = useState(false);
  const spinner = document.getElementById("lodingSpinner");
  if (spinner) {
    setTimeout(() => {
      spinner.style.display = "none";
      setLodingSpinner(true);
    }, 3500);
  }
  return (
    <>
      {lodingSpinner && (
        <>
          <Provider store={store} >
            <PersistGate loading={null} persistor={persistor}>
              <PrimeReactProvider>
                <ThemeProvider>
                  <ProjectRoute />
                </ThemeProvider>
              </PrimeReactProvider>
            </PersistGate>
          </Provider>
        </>
      )
      }
    </>
  )
}
